/* refonte-produit.js - genere depuis CLEAN-TWIN-PRODUIT.html - NE PAS EDITER A LA MAIN */
(function(){
  var RF = document.getElementById('rf-produit') || document;
  var doc = document.documentElement;
  doc.classList.add('js');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(){ RF.querySelectorAll('[data-rv]').forEach(function(n){ n.classList.add('on'); }); }

  /* 1. Reveal au scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
  RF.querySelectorAll('[data-rv]').forEach(function(n){ io.observe(n); });

  /* Filet de sécurité : onglet caché ou IO inactif, on n'ampute jamais le contenu */
  if(rm || document.visibilityState === 'hidden') showAll();
  addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') showAll(); });
  setTimeout(function(){
    var last = RF.querySelectorAll('[data-rv]');
    if(last.length && !last[0].classList.contains('on')) showAll();
  }, 3000);

  /* 2. Galerie */
  var galimg = RF.querySelector('#galimg'), thumbs = RF.querySelectorAll('.gal__t');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      t.setAttribute('aria-pressed','true');
      if(galimg && t.dataset.src){ galimg.removeAttribute('srcset'); galimg.src = t.dataset.src; galimg.alt = t.dataset.alt || ''; }
    });
  });

  /* 3. Sélecteur de quantité */
  var opts = RF.querySelectorAll('.qopt'),
      bp = RF.querySelector('#btnprice'),
      sp = RF.querySelector('#stickyprice');
  opts.forEach(function(o){
    o.addEventListener('click', function(){
      opts.forEach(function(x){ x.classList.remove('on'); });
      o.classList.add('on');
      var inp = o.querySelector('input'); if(inp) inp.checked = true;
      var tot = o.dataset.total || '';
      if(bp) bp.textContent = tot;
      if(sp) sp.textContent = tot;
    });
  });

  /* 4. Barre d'achat collante mobile */
  var sticky = RF.querySelector('#sticky'), buy = RF.querySelector('#rf-form') || RF.querySelector('#achat');
  if(sticky && buy){
    var io3 = new IntersectionObserver(function(es){
      es.forEach(function(e){ sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, {threshold:0});
    io3.observe(buy);
    var sbtn = RF.querySelector('#stickybtn');
    if(sbtn) sbtn.addEventListener('click', function(){
      var f = RF.querySelector('#rf-form');
      if(f && !sbtn.disabled){ f.submit(); return; }
      buy.scrollIntoView({behavior: rm ? 'auto' : 'smooth', block:'start'});
    });
  }

  /* 5. Spotlight curseur sur le bloc achat (desktop, hors reduced-motion) */
  if(buy && !rm && matchMedia('(hover: hover)').matches){
    buy.classList.add('spot');
    var raf=0, x=50, y=28;
    buy.addEventListener('mousemove', function(e){
      var r=buy.getBoundingClientRect();
      x=((e.clientX-r.left)/r.width)*100; y=((e.clientY-r.top)/r.height)*100;
      if(!raf) raf=requestAnimationFrame(function(){ buy.style.setProperty('--mx',x+'%'); buy.style.setProperty('--my',y+'%'); raf=0; });
    }, {passive:true});
  }
})();
/* menu mobile */
(function(){
  var hd = document.querySelector('[id^="rf-"] .hd') || document.querySelector('.hd');
  if(!hd) return;
  var b = hd.querySelector('.brg');
  if(!b) return;
  b.addEventListener('click', function(){
    var open = hd.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  });
  hd.querySelectorAll('.nav a').forEach(function(a){
    a.addEventListener('click', function(){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('click', function(e){
    if(hd.classList.contains('is-open') && !hd.contains(e.target)){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    }
  });
})();
